import NavigationBarControl from '../../../lib/ui/NavigationBarControl'
import IndexList from '../../../lib/ui/IndexControl'
import PositionForm from '../ui/PositionForm'
import PositionModel from '../model/PositionModel'
import LogentryModel from '../../logentry/model/LogentryModel'
import ObjectTypeMapping from '../../constants/ObjectTypeMapping'

export default class EditPosition {
  constructor (element, args) {
    this.onchange = () => {
      this.data = this.positionForm.getValue()
      window.PRIM.initDelayedNavigation()
      window.PRIM.dataAccess.put('positions', this.data.getJSON()).then((position) => {
        if (!window.PRIM.isDelayedNavigationActive())
        {
          return
        }

        if (args && !args.id && position.id) {
          window.PRIM.navigate('/positions/' + position.id, true)
        }

        if (position) {
          this.data.values.id = position.id
          this.positionForm.setValue(this.data)
        }        
      })
    }

    if (args) {
      if (args.id) {
        window.PRIM.dataAccess.resolve('positions', args.id, true).then((position) => {
          this.data = position

          window.PRIM.dataAccess.get('logentries').then((logentries) => {
            let results = logentries.filter((logentry) => {
              return logentry.target_id === this.data.values.id && logentry.object_type_id === ObjectTypeMapping.position
            })

            this.data.logentries = results.map((logentry) => {
              return new LogentryModel(logentry)
            })

            this.logIndex.setItems(this.data.logentries)
            this.positionForm.setValue(this.data)
          }, () => {
            this.positionForm.setValue(this.data)
          }).catch(() => {
          })
        }, () => {
          if (confirm('Deze functie bestaat niet, mogelijk is deze intussen verwijderd. Wilt u een nieuwe functie aanmaken?')) {
            window.PRIM.navigate('/positions/')
          } else {
            history.back()
          }
        }).catch(() => {
        })
      } else if (args.person_id) {
        window.PRIM.dataAccess.resolve('people', args.person_id, true).then((person) => {
          this.data = new PositionModel()
          this.data.values.person_id = person.values.id
          this.data.person = person
          this.positionForm.setValue(this.data)
        })
      } else if (args.location_id) {
        window.PRIM.dataAccess.resolve('locations', args.location_id, true).then((location) => {
          this.data = new PositionModel()
          this.data.values.location_id = location.values.id
          this.data.location = location
          this.positionForm.setValue(this.data)
        })
      }
    }

    this.data = new PositionModel()

    let fragment = document.createDocumentFragment()
    new NavigationBarControl(fragment, {
      title: 'Functie bewerken',
      leftHandButtons: [{
        onclick: () => {
          history.back()
        },
        icon: '\ue00d'
      },
        {
          onclick: () => {
            history.forward()
          },
          icon: '\ue01a'
        },
        {
          onclick: () => {
            window.PRIM.navigate('/start/')
          },
          icon: '\ue08a'
        },
        {
          onclick: this.onchange,
          icon: '\ue020',
          classes: 'indicator'
        }],
      contextMenu: [
        {
          onclick: () => {
            if (this.data.values.id) {
              window.PRIM.navigate('/logentries/position/' + this.data.values.id)
            } else {
              alert('Vul eerst gegevens voor deze functie.')
            }
          },
          icon: '\ue032',
          label: 'Logboekregel'
        },
        {
          onclick: () => {
            if (this.data.values.id) {
              if (confirm('Weet u het zeker dat u deze functie wilt verwijderen?')) {
                window.PRIM.dataAccess.delete('positions', this.data.values.id).then(() => {
                  history.back()
                })
              }
            } else {
              alert('Vul eerst gegevens voor deze functie.')
            }
          },
          icon: '\ue123',
          label: 'Verwijderen'
        }
      ]
    })

    let div = document.createElement('div')
    div.className = 'viewport'

    let divContent = document.createElement('div')
    divContent.className = 'content'

    let primaryData = document.createElement('section')
    primaryData.className = 'primary'
    let secondaryData = document.createElement('section')
    secondaryData.className = 'secondary'

    this.positionForm = new PositionForm(primaryData, {position: this.data, onchange: this.onchange})

    let fieldsetLog = document.createElement('fieldset')
    let legendLog = document.createElement('legend')
    legendLog.innerHTML = 'Logboek'
    fieldsetLog.appendChild(legendLog)

    let onclickLogentry = (item) => {
      window.PRIM.navigate('/logentries/' + item.values.id)
      return
    }

    this.logIndex = new IndexList(fieldsetLog, {items: this.data.logentries, reverse: true, showImage: false, onclick: onclickLogentry})

    secondaryData.appendChild(fieldsetLog)

    divContent.appendChild(primaryData)
    divContent.appendChild(secondaryData)
    div.appendChild(divContent)
    fragment.appendChild(div)

    element.appendChild(fragment)
  }
}



// WEBPACK FOOTER //
// ./js/modules/position/action/EditPosition.js